import React from 'react';
import showIconBlack from '../../assets/visbleBlack.svg';
import hidenIcon from '../../assets/visibleBlack_off.png';
import './Input.css';

interface Props {
  htmlFor?: string;
  children?: React.ReactNode;
  type?: any;
  onClick?: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  editable?: boolean;
  labelName?: string;
  id?: string;
  placeholder?: string;
  value?: any;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  isRequired?: boolean;
  isPassword?: boolean;
  handleShowPassword?: () => void;
  handleShowPasswordConfirmation?: () => void;
  showPassword?: boolean;
  showPasswordConfirmation?: boolean;
  className?: any;
  isErrorValidate?: boolean;
  messageError?: string;
  pattern?: string;
  maxLength?: number;
  checked?: boolean;
}
const Input: React.FC<Props> = ({
  isPassword = false,
  editable = true,
  checked = false,
  pattern,
  maxLength,
  isErrorValidate = false,
  messageError = '',
  className = 'input-pattern',
  handleShowPassword,
  showPassword,
  isRequired = false,
  htmlFor,
  labelName,
  placeholder,
  value,
  id,
  type = 'text',
  onKeyDown,
  onChange,
  onBlur,
  children,
  style,
  onClick,
  disabled = false,
}) => {
  if (type === 'radio') {
    return (
      <div className='input-radio-container-pattern'>
        {value !== undefined && value !== null ? (
          <label className='label-input-radio-pattern' htmlFor={htmlFor}>
            <input
              placeholder={placeholder}
              id={id}
              className='input-radio-pattern'
              type={type}
              disabled={disabled}
              onClick={onClick}
              style={style}
              onKeyDown={onKeyDown}
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              pattern={pattern}
              maxLength={maxLength}
              contentEditable={editable}
              checked={checked}
            />
            <span className='label-input-text-radio-pattern'>{labelName}</span>
          </label>
        ) : null}
      </div>
    );
  } else {
    return (
      <div className='input-container-pattern'>
        {labelName && (
          <label className='label-pattern' htmlFor={htmlFor}>
            {labelName} {isRequired && <b>*</b>}
          </label>
        )}
        {!isPassword ? (
          <input
            placeholder={placeholder}
            id={id}
            className={className}
            type={type}
            disabled={disabled}
            onClick={onClick}
            style={style}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            pattern={pattern}
            maxLength={maxLength}
            contentEditable={editable}
          />
        ) : (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              placeholder={placeholder}
              id={id}
              className={className}
              type={type}
              disabled={disabled}
              onClick={onClick}
              style={style}
              onKeyDown={onKeyDown}
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              pattern={pattern}
              maxLength={maxLength}
              contentEditable={editable}
            />
            <span
              style={{
                position: 'relative',
                right: '15px',
                cursor: 'pointer',
                marginTop: '6px',
              }}
              className='password-input-show-icon-register'
              onClick={handleShowPassword}
            >
              {showPassword && <img alt='show-icon' src={showIconBlack} />}
              {!showPassword && <img alt='hiden-icon' src={hidenIcon} />}
            </span>
          </div>
        )}

        {isErrorValidate ? (
          <p className='input-error-message'>{messageError}</p>
        ) : null}
      </div>
    );
  }
};

export default Input;
